import {
    ColorOrangeDark1 as lightColor,
    ColorBlueDark1 as sleepColor,
    ColorGreenDark2 as activitiesColor,
    ColorGreenPrimary,
    ColorYellowDark3,
    ColorOrangeDark2,
    ColorRedPrimary,
    ColorWhite,
    ColorLightuiAccent1
} from 'ui-connect/styles/default-theme';

import { jetLagRoute } from 'routes/obfuscatedRoutes';

export const TRIP_TYPES = {
    ONE_WAY: 'ONE_WAY',
    MULTI_CITY: 'MULTI_CITY',
    ROUNDTRIP: 'ROUNDTRIP'
};

export const JET_LAG_LEVELS_COLORS = {
    acclimated: ColorGreenPrimary,
    mild: ColorGreenPrimary,
    moderate: ColorYellowDark3,
    significant: ColorOrangeDark2,
    severe: ColorRedPrimary,
    white: ColorWhite,
    preTrip: ColorLightuiAccent1
};

export const JET_LAG_SEVERITY_TYPES = {
    ACCLIMATED: 1,
    MILD: 2,
    MODERATE: 3,
    SIGNIFICANT: 4,
    SEVERE: 5
};

export const JET_LAG_GUIDANCE_CATEGORIES = {
    LIGHT: {
        id: 'LIGHT',
        iconClassName: 'icon-jetlag-light',
        color: lightColor
    },
    SLEEP: {
        id: 'SLEEP',
        iconClassName: 'icon-jetlag-sleep',
        color: sleepColor
    },
    ACTIVITIES: {
        id: 'ACTIVITIES',
        iconClassName: 'icon-jetlag-activity',
        color: activitiesColor
    }
};

// order matters here
export const JET_LAG_GUIDANCE_CATEGORIES_ON_CHART = [
    JET_LAG_GUIDANCE_CATEGORIES.LIGHT.id,
    JET_LAG_GUIDANCE_CATEGORIES.SLEEP.id,
    JET_LAG_GUIDANCE_CATEGORIES.ACTIVITIES.id
];

/**
 * @typedef {{
 *  type: string;
 *  category: string;
 *  color: string;
 *  borderColor: string;
 * }} JetLagGuidance
 *
 * @type {{
 *  [key: string]: JetLagGuidance
 * }}
 */
export const JET_LAG_GUIDANCE_TYPES = {
    LHA_JET_LAG_NOTIFICATION_TYPE_LIGHT_EXPOSE: {
        type: 'LHA_JET_LAG_NOTIFICATION_TYPE_LIGHT_EXPOSE',
        category: JET_LAG_GUIDANCE_CATEGORIES.LIGHT.id,
        color: lightColor,
        borderColor: lightColor
    },
    LHA_JET_LAG_NOTIFICATION_TYPE_LIGHT_AVOID: {
        type: 'LHA_JET_LAG_NOTIFICATION_TYPE_LIGHT_AVOID',
        category: JET_LAG_GUIDANCE_CATEGORIES.LIGHT.id,
        color: 'transparent',
        borderColor: lightColor
    },
    LHA_JET_LAG_NOTIFICATION_TYPE_LIGHT_AVOID_END: {
        type: 'LHA_JET_LAG_NOTIFICATION_TYPE_LIGHT_AVOID_END',
        category: JET_LAG_GUIDANCE_CATEGORIES.LIGHT.id,
        color: 'transparent',
        borderColor: lightColor
    },
    LHA_JET_LAG_NOTIFICATION_TYPE_SLEEP: {
        type: 'LHA_JET_LAG_NOTIFICATION_TYPE_SLEEP',
        category: JET_LAG_GUIDANCE_CATEGORIES.SLEEP.id,
        color: sleepColor,
        borderColor: sleepColor
    },
    LHA_JET_LAG_NOTIFICATION_TYPE_ACTIVITIES: {
        type: 'LHA_JET_LAG_NOTIFICATION_TYPE_ACTIVITIES',
        category: JET_LAG_GUIDANCE_CATEGORIES.ACTIVITIES.id,
        color: activitiesColor,
        borderColor: activitiesColor
    }
};

export const LHA_JET_LAG_FEEDBACK_UNKNOWN = 'LHA_JET_LAG_FEEDBACK_UNKNOWN';
export const LHA_JET_LAG_BODY_CLOCK_SHIFT_FEEDBACK_UNKNOWN = 'LHA_JET_LAG_BODY_CLOCK_SHIFT_FEEDBACK_UNKNOWN';

export const JET_LAG_EDIT_TRIP_URL = `/${jetLagRoute}/edit`;
export const JET_LAG_SETUP_TRIP_URL = `/${jetLagRoute}/setup`;
export const JET_LAG_MANAGE_TRIPS_URL = `/${jetLagRoute}/manage-trips`;
export const JET_LAG_FROM_CALENDAR_QUERY_PARAM = 'fromCalendar=true';
export const JET_LAG_CALENDAR_DATE_QUERY_PARAM = 'calendarDate';

export const STATUS_CODE_NO_CONTENT = 204;

export const MAX_NUMBER_OF_JET_LAG_TRIPS = 25;
